import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultTextOrArrayValue, DefaultTextOrValue, DateFromNow, SanitizeHTML, FilterByFields, SecurityPipe, SearchValuePropertyPipe, CurrencyEuroPipe, MaskVatNumberPipe, MaskZeroNumberPipe, CurrencyFormatterPipe, JsonTreeValuePipe } from './generic.pipe';

const importedPipes =
    [
        DefaultTextOrArrayValue,
        DefaultTextOrValue,
        SanitizeHTML,
        DateFromNow,
        FilterByFields,
        SecurityPipe,
        SearchValuePropertyPipe,
        CurrencyEuroPipe,
        MaskVatNumberPipe,
        MaskZeroNumberPipe,
        CurrencyFormatterPipe,
        JsonTreeValuePipe
    ];

@NgModule(
    {
        imports:
            [
                CommonModule
            ],
        declarations: importedPipes,
        exports: importedPipes
    })
export class PipesModule { }
